import { useLocation, useNavigate } from "react-router-dom";
import { CustomButton } from "../components/CustomButton";
import { Check, ClipboardList } from "lucide-react";
import rushLogo from "../assets/png/rush-logo.png";

type OrderSuccessState = {
  orderId?: string;
};

export default function OrderSuccessScreen() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const orderSuccessState = (state as OrderSuccessState | null) ?? null;
  const orderId = orderSuccessState?.orderId ?? "RSH-7721";

  return (
    <div className="min-h-[100dvh] bg-white px-8 flex flex-col items-center justify-center">
      
      <div className="w-full max-w-[320px] flex flex-col items-center">
        <img 
          src={rushLogo} 
          alt="Rush Logo" 
          className="h-6 w-auto object-contain mb-10" 
        />

        <div className="relative mb-6">
          <div className="absolute inset-0 bg-[#44B6CE]/10 rounded-full scale-125" />
          <div className="relative w-16 h-16 bg-[#44B6CE] rounded-full flex items-center justify-center shadow-lg shadow-cyan-100">
            <Check size={32} strokeWidth={3} className="text-white" />
          </div>
        </div>

        <div className="text-center mb-8">
          <h2 className="text-xl font-black text-gray-900 tracking-tight">
            Order Placed!
          </h2>
          <p className="text-gray-500 text-[13px] font-medium mt-1.5 leading-relaxed">
            Your laundry request is now being processed by our team.
          </p>
        </div>

        <div className="w-full bg-gray-50 border border-gray-100 rounded-[22px] p-4 mb-8">
          <div className="flex items-center gap-3">
            <div className="bg-white p-2.5 rounded-xl shadow-sm border border-gray-100 flex-shrink-0">
              <ClipboardList className="text-[#44B6CE]" size={18} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">
                Order Reference
              </p>
              <p className="text-sm font-black text-gray-800 truncate">
                #{orderId}
              </p>
            </div>
          </div>
          
          <div className="w-full border-t border-dashed border-gray-200 my-3" />
          
          <p className="text-[10px] text-gray-400 font-medium text-center italic">
            "We'll notify you when a driver is assigned."
          </p>
        </div>

        <CustomButton
          variant="primary"
          className="w-full h-12 text-sm rounded-xl font-bold shadow-md shadow-cyan-50 active:scale-[0.97] transition-all"
          onClick={() => navigate("/dashboard")}
        >
          Done
        </CustomButton>
      </div>
    </div>
  );
}